export const setUpBlockAccordion = function() {
	document.addEventListener("click", function(event) {
		// クリックされた要素が指定されたセレクターに一致するか確認
		if (event.target.closest(".wp-block-new-standard-block-accordion.is-accordion-enabled .wp-block-new-standard-block-accordion-inner__title")) {
			const titleElement = event.target.closest(".wp-block-new-standard-block-accordion-inner__title");

			// クラスのトグル
			titleElement.parentElement.classList.toggle("open");

			/*// 対応するコンテンツ要素を取得
			const contentElement = titleElement.nextElementSibling;

			// スライドトグルの実装
			if (contentElement.style.display === "none" || !contentElement.style.display) {
				contentElement.style.display = "block";
				contentElement.style.height = "0px"; // 初期高さを0に
				const fullHeight = contentElement.scrollHeight + "px"; // フルサイズの高さを取得
				contentElement.style.transition = "height 0.3s ease";
				contentElement.style.height = fullHeight;

				contentElement.addEventListener("transitionend", function onTransitionEnd() {
					contentElement.style.height = ""; // 高さをリセットして自然なサイズに
					contentElement.removeEventListener("transitionend", onTransitionEnd);
				});
			} else {
				contentElement.style.height = contentElement.scrollHeight + "px"; // 現在の高さを設定
				requestAnimationFrame(() => {
					contentElement.style.transition = "height 0.3s ease";
					contentElement.style.height = "0px";
				});

				contentElement.addEventListener("transitionend", function onTransitionEnd() {
					contentElement.style.display = "none"; // 非表示に
					contentElement.style.height = ""; // 高さをリセット
					contentElement.removeEventListener("transitionend", onTransitionEnd);
				});
			}*/
		}
	});
};
